/* eslint-disable no-unused-vars */
import { DEFAULT_AUTO_ROTATE_SPEED } from 'consts';
import { SCENES_AUTO_PLAY } from 'consts/configCustom';
import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setAutoRotate } from 'store/actions';

function moveTime(tocDo, banKinh) {
  // Tính chu vi của đường tròn
  var chuVi = 2 * Math.PI * banKinh;

  // Tính thời gian di chuyển
  var thoiGian = chuVi / tocDo;

  return thoiGian;
}

const HandleAutoRotate = ({
  shouldRotate,
  scenes,
  currentPano,
  onChangeScene,
}) => {
  const autoPlay = useSelector((state) => state.autoPlayMode);
  const autoRotateSpeed = useSelector((state) => state.tour.autoRotateSpeed);
  const dispatch = useDispatch();

  const intervalInstance = useRef(null);

  useEffect(() => {
    dispatch(setAutoRotate(autoPlay));
  }, [autoPlay, dispatch]);

  const isRotate = useMemo(() => {
    if (!shouldRotate || !autoPlay) {
      return false;
    } else return true;
  }, [autoPlay, shouldRotate]);

  const handleAutoPlay = useCallback(() => {
    if (scenes.length === 0) return;
    if (!currentPano) return;

    let currentIndex = SCENES_AUTO_PLAY.findIndex(
      (item) => item === currentPano?.id
    );

    if (currentIndex === -1) return;
    // change speed
    const rotateSpeed = autoRotateSpeed || DEFAULT_AUTO_ROTATE_SPEED;

    const fetchData = () => {
      console.log(currentIndex);

      if (currentIndex === SCENES_AUTO_PLAY.length - 1) {
        currentIndex = 0;
      } else {
        currentIndex++;
      }
      const currentScene = scenes.find(
        (scene) => scene.id === SCENES_AUTO_PLAY[currentIndex]
      );
      onChangeScene(currentScene.groupId, currentScene.id);
    };

    if (isRotate) {
      // first run:
      // fetchData();

      // loop through scenes:
      clearInterval(intervalInstance.current);
      intervalInstance.current = setInterval(
        fetchData,
        moveTime(rotateSpeed, 3.5) * 2000
      );
    }
  }, [scenes, currentPano, autoRotateSpeed, isRotate, onChangeScene]);

  const handleAutoPlayEvent = () => {
    handleAutoPlay();
  };

  useEffect(() => {
    autoPlay && document.addEventListener('autoPlay', handleAutoPlayEvent);
    handleAutoPlay();

    return () => {
      clearInterval(intervalInstance.current);
      document.removeEventListener('autoPlay', handleAutoPlayEvent);
    };
    // eslint-disable-next-line
  }, [autoRotateSpeed, autoPlay, isRotate]);

  // Lắng nghe sự thay đổi của scenes và reset interval
  useEffect(() => {
    if (isRotate) {
      handleAutoPlay(); // Reset lại interval khi scenes thay đổi
    }
    return () => {
      clearInterval(intervalInstance.current); // Clear interval khi scenes thay đổi
    };
  }, [scenes, isRotate, handleAutoPlay]);

  return <></>;
};

export default HandleAutoRotate;
